import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store/store";
import LoadingIcon from "./components/LodingIcon";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <BrowserRouter>
    <StrictMode>
      <Provider store={store}>
        {/*
          Without this gate the app mounted with initialState even when the
          catalogues were sitting in localStorage: every effect fired once
          against the empty store and again once rehydration landed. 19+ effects
          carry businessUnit?.code in their dependencies, so each of them ran
          once with undefined and once with the real code, and App's own startup
          effects fetched the heaviest payload of the app twice on every load.

          The cost is that first paint now waits for rehydration, which is a
          synchronous read of localStorage. That is the trade we chose: a few
          milliseconds of spinner against a duplicated request storm.
        */}
        <PersistGate
          loading={
            <div className="flex items-center justify-center h-screen">
              <LoadingIcon size="5rem" />
            </div>
          }
          persistor={persistor}
        >
          <App />
        </PersistGate>
      </Provider>
    </StrictMode>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
